// TEAM_005: Tournament prize payout API — returns any payout record for the
// current user + tournament (WINNER_REWARD, OVERPAYMENT_REFUND, or CANCEL_REFUND).

import apiClient from './apiClient';
import type {
  GetTournamentPrizePayoutMeResponse,
} from '../types/tournamentPrizePayout';

type TournamentId = string | number;

const formatTournamentId = (id: TournamentId): string => String(id);

export const getTournamentPrizePayoutForMe = async (
  tournamentId: TournamentId,
): Promise<GetTournamentPrizePayoutMeResponse> => {
  const response = await apiClient.get<GetTournamentPrizePayoutMeResponse>(
    `/tournament-prize-payouts/tournaments/${formatTournamentId(tournamentId)}/me`,
  );

  return response.data;
};
